<script setup lang="ts">
import AskOdds from './splash/AskOdds.vue'
import AskBookmaker from './splash/AskBookmaker.vue'
import BetPic from './splash/BetPic.vue'

defineProps<{
  show: boolean
  mode: string
  isLoading: boolean
}>()

defineEmits(['animation-complete'])
</script>

<template>
  <template v-if="show">
    <AskOdds
      v-if="mode === 'odds'"
      :isLoaded="!isLoading"
      @animation-complete="$emit('animation-complete')"
    />
    <AskBookmaker
      v-else-if="mode === 'direct'"
      :isLoaded="!isLoading"
      @animation-complete="$emit('animation-complete')"
    />
    <BetPic
      v-else-if="mode === 'betpic'"
      :isLoaded="!isLoading"
      @animation-complete="$emit('animation-complete')"
    />
  </template>
</template>
